/**
 * Small "Default" pill marking the player's default shipping address. Green
 * accent, themeable via `--co-DefaultBadge-*`; the translucent-green fill
 * reads on both the dark Delivery card and the light address picker.
 */
export function DefaultBadge() {
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-[2px] text-[11px] font-semibold leading-none"
      style={{
        background: 'var(--co-DefaultBadge-bg, rgba(34,225,28,0.16))',
        color: 'var(--co-DefaultBadge-fg, #16B814)',
      }}
    >
      Default
    </span>
  );
}
